import React, { Component, useEffect, useState } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from "recharts";
import { getRoundedInrFormat } from "../../../../utilities";

/*

* Constants
  
*/

const COLORS = ["rgb(0, 156, 255)", "#87C756"];

/*

* React Class Component
  
*/

class ResultChart extends Component {
  state = {
    activeIndex: 0,
    userDimensions: { width: null, height: null }
  };

  handleResize = () => {
    this.setState({
      userDimensions: { width: window.innerWidth, height: window.innerHeight }
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.setState({
      userDimensions: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index
    });
  };

  render() {
    const { data } = this.props;

    return (
      <section
        className="chartContainer"
      >
        <ResponsiveContainer width="100%" height={350}>
          <PieChart
            width={this.state.userDimensions.width <= 1024 ? 650 : 750}
            height={400}
          >
            <Pie
              activeIndex={this.state.activeIndex}
              activeShape={renderActiveShape}
              data={data}
              cx="50%"
              cy={160}
              innerRadius={70}
              outerRadius={110}
              paddingAngle={2}
              offset={20}
              onMouseEnter={this.onPieEnter}
            >
              {this.props.data &&
                this.props.data.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <style jsx>{`
          .chartContainer {
            margin-top: 24px;
          }
          @media (max-width:600px){
            .chartContainer {
              display: none;
            }
          }
        `}</style>
      </section>
    );
  }
}

/*

* React FC
  
*/

const renderActiveShape = props => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 40;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text
        x={cx}
        y={cy - 16}
        dy={8}
        textAnchor="middle"
        fill="#4D4D4D"
        style={{ fontSize: "12px", lineHeight: "18px" }}
      >
        {payload.nameTwo}
      </text>
      <text
        x={cx}
        y={cy + 12}
        dy={8}
        textAnchor="middle"
        fill="#000000"
        style={{
          fontSize: "24px",
          fontFamily: "Hind Madurai",
          lineHeight: "36px",
          fontWeight: "bold"
        }}
      >
        {"₹" + getRoundedInrFormat(payload.valueTwo)}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 10}
        y={ey}
        dy={-6}
        textAnchor={textAnchor}
        fill="#4D4D4D"
        style={{
          fontFamily: "Hind Madurai",
          fontSize: "12px",
          lineHeight: "18px"
        }}
      >
        {payload.name}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 10}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#000"
        style={{
          fontFamily: "Hind Madurai",
          fontSize: "16px",
          fontWeight: "bold",
          lineHeight: "24px"
        }}
      >
        {`₹${getRoundedInrFormat(value)}`}
      </text>
    </g>
  );
};

export default ResultChart;
